ACC.autocomplete = {
  dataMinChar: 'data-minchar',
  searchAutoCompleteData: '',
  bindAll: function() {
    ACC.autocomplete.getAutocompleteData();
  },

  bindSearchAutocomplete: function(id) {
    var minChar = $(id).attr(ACC.autocomplete.dataMinChar),
        minLen = parseInt(minChar, 10);

    $(id).autocomplete({
      source: function(request, response) {
        $.getJSON(ACC.autocompleteUrl,
          {
            term: $(id).val()
          },
          function(data) {
            response(data);
          });
      },
      minLength: minLen || 2,

      open: function() {
        $('.ui-menu').css('z-index', 10000);
      },
      close: function() {
        $('.ui-menu').css('z-index', -1);
      },
      select: function(ui) {
        if ($('.ui-autocomplete').find('.ui-menu-item .ui-state-active').length > 0) {
          $(id).val($.trim($('.ui-autocomplete').find('.ui-menu-item .ui-state-active').text()));
        }

        if (ui.item) {
          $(id).val($.trim(ui.item.value));
        }

        $(id).parent('form[name="search_form"]').submit();
      },
      autoFocus: false

    });
  },
  setAutocompleteData: function(responce) {
    var $searchnoresult = '#ph-search_noresult',
        $searchmobile = '#search_mobile',
        $searchdesktop = '#search_desktop';

    $($searchmobile).attr(ACC.autocomplete.dataMinChar, responce);
    ACC.autocomplete.bindSearchAutocomplete($searchmobile);
    $($searchdesktop).attr(ACC.autocomplete.dataMinChar, responce);
    ACC.autocomplete.bindSearchAutocomplete($searchdesktop);
    $($searchnoresult).attr(ACC.autocomplete.dataMinChar, responce);
    ACC.autocomplete.bindSearchAutocomplete($searchnoresult);
    $('#searchcomponent_input').attr(ACC.autocomplete.dataMinChar, responce);
    ACC.autocomplete.bindSearchAutocomplete('#searchcomponent_input');
    sessionStorage.setItem('searchAutoCompleteData', responce);
  },
  getAutocompleteData: function() {
    var $elms = $('#search_mobile, #search_desktop, #ph-search_noresult');

    if ($elms.attr(ACC.autocomplete.dataMinChar) === '' && (sessionStorage.getItem('searchAutoCompleteData') === null || '')) {
      $.getJSON($('#ph-setautocomplete_url').val(), ACC.autocomplete.setAutocompleteData);
    } else {
      var sessionStore = sessionStorage.getItem('searchAutoCompleteData');

      ACC.autocomplete.setAutocompleteData(sessionStore);
    }
  }
};

$(document).ready(function() {
  ACC.autocomplete.bindAll();
});
